import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
    userInfo: {
        id: 0,
        nickName: "",
        avatarUrl: "",
        role: ""
    },
    machineId: "",
    help: false,
    token: "",
    needUpdatePassword: false,
    topic: {},
    filePreviewURL: "https://exam.bsm1747.cn:8012/",
    //fileURL: "http://192.168.10.20:5000", // api的base_url
    //baseURL: "http://192.168.10.20:5000/api/", // api的base_url
    //fileURL: "http://192.168.5.119:9999", // api的base_url
    //baseURL: "http://192.168.5.119:9999/api/", // api的base_url
    fileURL: "https://exam.bsm1747.cn:9999", // api的base_url
    baseURL: "https://exam.bsm1747.cn/api/"
};

const store = new Vuex.Store({
    state: state
});

export default store
